import { Fragment, memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminLocation } from 'utils/hooks';
import { BreadcrumbItem, HomeButton } from './AdminBreadcrumb.styles';

export const AdminBreadcrumb = memo(() => {
  const navigate = useNavigate();
  const { pageNames, title, filteredPathnameArr } = useAdminLocation();

  useEffect(() => {
    if (pageNames.length > 0) {
      document.title = `${title} | Flowio`;
    }
  }, [pageNames, title]);

  if (!pageNames.length) return null;

  return (
    <>
      <BreadcrumbItem onClick={() => navigate('/admin')} data-testid="admin-breadcrumb-home">
        <HomeButton fontSize="small" />
      </BreadcrumbItem>
      {pageNames.map((pageName, index) => (
        <Fragment key={pageName}>
          <BreadcrumbItem
            data-testid={`admin-breadcrumb-item-${filteredPathnameArr[index]}`}
            onClick={() => {
              if (index === pageNames.length - 1 && filteredPathnameArr.length !== pageNames.length) return;
              navigate(
                `/${filteredPathnameArr
                  .slice(0, index + 1)
                  .join('/')
                  .replace(/([a-z])([A-Z])/g, '$1-$2')
                  .toLowerCase()}`
              );
            }}
            key={pageName}>
            {pageName}
          </BreadcrumbItem>
        </Fragment>
      ))}
    </>
  );
});
